import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import HomePage from "../components/display";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { ASSISTANT_URL } from '../constants';
import { ChatContext } from '../context/ChatContext';
import Chat from "./chat";
import { AuthContext } from '../context/AuthContext';

const Dashboard = () => {  
  const { setUser, setCourse } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const nom = searchParams.get('nom')
  const curso = searchParams.get('curso')

  const fetchUserDetails = async (nom) => {
    try {
        const response = await axios.post(`${ASSISTANT_URL}/api/auth/nom`, { nom });
        setUser(response.data); // Assume the response contains user details
    } catch (error) {
        console.error("fetchUserDetails: Error fetching user details:", error);
    }
  };

  const fetchCourseDetails = async (curso) => {
    try {
        const response = await axios.post(`${ASSISTANT_URL}/api/auth/curso`, { curso });
        setCourse(response.data); // Assume the response contains user details
    } catch (error) {
        console.error("fetchCourseDetails: Error fetching course details:", error);
    }
  };
    
  useEffect(() => {
    if (nom) {
        fetchUserDetails(nom);
        handleNewDialogClick()
    }
  }, [nom]);

  useEffect(() => {
    if (curso) {
        fetchCourseDetails(curso);
    }
  }, [curso]);
  
  const { chatShow, setChatShow, setChatMessage, setShowChatTime, showChatTime } = useContext(ChatContext);

  // Handler to initiate a new chat dialog
  const handleNewDialogClick = () => {
    setChatShow(true); // Show the chat interface
    setChatMessage([]); // Clear any existing chat messages
    setShowChatTime(new Date().toISOString()); // Update the chat timestamp
  };

  return (
    <div className="font-Inter flex items-start relative min-h-screen">
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className={`flex flex-col transition-all duration-300 w-full h-screen bg-white-200 ${isOpen ? "lg:ml-0" : "lg:-ml-80"}`}>
        <Header />
        {!chatShow ? (
          <HomePage onNewDialogClick={handleNewDialogClick} /> // Render HomePage if chat is not shown
        ) : (
          <Chat time={showChatTime} /> // Render Chat component if chat is shown
        )}
      </div>
    </div>
  );
};

export default Dashboard;
